import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RolPlataforma } from '../../core/models/novedades.models';
import { RoleContextService } from '../../core/services/role-context.service';
import { AccessibilityToolbar } from '../../shared/components/accessibility-toolbar/accessibility-toolbar';
import { BreadcrumbItem, Breadcrumbs } from '../../shared/components/breadcrumbs/breadcrumbs';
import { HeaderNotificationBell } from '../../shared/components/header-notification-bell/header-notification-bell';
import { UserSessionSummary } from '../../shared/components/user-session-summary/user-session-summary';
import { SidebarMenu } from '../../shared/sidebar-menu/sidebar-menu';
import { InvitacionesPanel } from './components/invitaciones-panel/invitaciones-panel';

@Component({
  selector: 'app-invitaciones',
  imports: [
    CommonModule,
    SidebarMenu,
    HeaderNotificationBell,
    AccessibilityToolbar,
    Breadcrumbs,
    UserSessionSummary,
    InvitacionesPanel,
  ],
  templateUrl: './invitaciones.html',
  styleUrl: './invitaciones.css',
})
export class Invitaciones {
  readonly breadcrumbs: BreadcrumbItem[] = [{ label: 'Inicio', link: '/principal' }, { label: 'Invitaciones' }];
  rol: RolPlataforma = 'postulante';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly roleContext: RoleContextService
  ) {
    this.route.queryParamMap.subscribe((params) => {
      this.rol = this.roleContext.resolveRole(params, this.rol);
    });
  }

  get subtitulo(): string {
    if (this.rol === 'postulante') return 'Revisa solicitudes para participar en otras postulaciones y confirma el rol que te estan proponiendo.';
    if (this.rol === 'recomendador') return 'Revisa las invitaciones disponibles para emitir recomendaciones.';
    return 'Revisa las invitaciones asociadas a tus postulaciones y su estado de respuesta.';
  }

  get mostrarPanelInvitaciones(): boolean {
    return this.rol === 'postulante' || this.rol === 'recomendador';
  }
}
